export default __webpack_public_path__ + "static/media/image81.bb0d264d.jpg";